import { IBaseIconProps } from "./IBaseIconProps";

export const DocumentCheckIcon = ({ color = "#000" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 125"
      fill={color}
    >
      <path d="M73.5,10H60.1c-0.6-3.9-4-7-8.1-7s-7.5,3.1-8.1,7H30.5c-4.1,0-7.5,3.4-7.5,7.5v65c0,4.1,3.4,7.5,7.5,7.5h43  c4.1,0,7.5-3.4,7.5-7.5v-65C81,13.4,77.6,10,73.5,10z M52,8c1.4,0,2.5,1.1,2.5,2.5S53.4,13,52,13s-2.5-1.1-2.5-2.5S50.6,8,52,8z   M73,80H31V20h6v5h30v-5h6V80z" />
      <path d="M45.9,54.3l-5.7-5.7c-1-1-2.6-1-3.5,0c-1,1-1,2.6,0,3.5l7.5,7.5c0.5,0.5,1.1,0.7,1.8,0.7c0.7,0,1.3-0.2,1.8-0.7L66.2,41  c1-1,1-2.6,0-3.5c-1-1-2.6-1-3.5,0L45.9,54.3z" />
    </svg>
  );
};
